import { IRole } from "@/dtos/role/IRole";
import { del, get, patch, post } from "../../utils/BaseService";


export async function getAllRole(dispatch: any) {
   return await get(dispatch, '/role/getAllRole', null)
}
export async function getAllFilterRoles(dispatch: any) {
   return await get(dispatch, '/role/getAllFilterRoles', null)
}
export async function createRole(dispatch: any, input: IRole) {
   return await post(dispatch, '/role/createRole', input)
}
export async function updateRole(dispatch: any, input: IRole, id: number) {
   return await patch(dispatch, '/role/updateRole', input, id)
}
export async function deleteRole(dispatch: any,id: number) {
   return await del(dispatch, '/role/deleteRole', id)
}